import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ASSETS } from "@/lib/brand";

const reasons = [
  { t: "Growth Strategies", b: "Tailored roadmaps designed to scale your property portfolio." },
  { t: "Risk Management", b: "Stress-tested plans that protect capital across market cycles." },
  { t: "Market Expertise", b: "Sharp, up-to-date intelligence on districts, regulations & trends." },
  { t: "Innovative Marketing", b: "Cinematic listings, YouTube tours, and high-converting outreach." },
];

export default function WhyChooseMe() {
  return (
    <section
      data-testid="home-why"
      className="section-pad bg-cream relative overflow-hidden"
    >
      <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <div className="eyebrow mb-4 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-bronze" /> The Difference
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05]">
            Why <span className="italic text-bronze">Choose</span> Me?
          </h2>
          <p className="mt-6 text-base md:text-lg text-ink_soft/80 font-light leading-relaxed">
            I don't just sell properties — I craft growth strategies, manage risk, and deliver
            personalized real estate experiences driven by market expertise and innovative
            marketing. Partner with me to transform properties into wealth and dreams into reality.
          </p>

          <Link
            to="/why-me"
            data-testid="why-cta"
            className="mt-8 inline-flex items-center gap-2 text-[0.72rem] tracking-[0.22em] uppercase text-bronze hover:text-bronze_dark"
          >
            Discover My Approach <ArrowRight size={16} />
          </Link>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {reasons.map((r, i) => (
            <div
              key={r.t}
              data-testid={`why-reason-${i}`}
              className="reveal border border-bronze/25 bg-beige/50 p-7 hover:bg-beige transition-colors"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="font-serif text-2xl text-ink leading-tight">{r.t}</div>
              <p className="mt-3 text-sm font-light text-ink_soft/80 leading-relaxed">
                {r.b}
              </p>
            </div>
          ))}
          <div className="reveal sm:col-span-2 relative aspect-[16/8] overflow-hidden mt-2">
            <img
              src={ASSETS.lifestyle.livingRoom}
              alt="Warm modern living room"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-ink/40 to-transparent" />
            <div className="absolute inset-0 p-8 flex items-end">
              <p className="font-serif italic text-cream text-2xl md:text-3xl max-w-md leading-snug">
                Properties become wealth — when planning meets patience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
